import { css } from "@emotion/react";

const CustomHomePageLayoutStyles = () => css``;

export default CustomHomePageLayoutStyles;
